import { Box, Card, CardContent, Divider, Typography } from '@mui/material'
import { useAllAtiveReunioesByInscricao } from 'entity/Reuniao/funtions'
import React from 'react'
import { dateHoraToStringIso } from 'util/date'


const CardReuniaoPainel = ({ tempoReuniao, reuniao, inscrito }) => {
    const participante = inscrito.uid === reuniao.inscricao1.uid ? reuniao.inscricao2.empresa.nomeEmpresaCracha : reuniao.inscricao1.empresa.nomeEmpresaCracha
    // let dateUsar = new Date("2025-08-01T14:14");//new Date()
    let dateUsar = new Date()
    dateUsar.setMinutes(dateUsar.getMinutes() - tempoReuniao);
    let strNow = dateHoraToStringIso(dateUsar)
    let color = reuniao.horario.horario < strNow ? 'lightgray' : 'white';
    
    return (<Card sx={{ mb: 2, bgcolor: color }}>
        <CardContent sx={{ p: { xs: 1.5, sm: 2 } }}>
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                gap: { xs: 1.5, sm: 2 },
                flexDirection: { xs: 'column', sm: 'row' },
                textAlign: { xs: 'center', sm: 'left' }
            }}>                    <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                minWidth: { xs: 'auto', sm: '120px' }
            }}>
                    <Typography
                        variant="h3"
                        fontWeight={600}
                        sx={{ fontSize: { xs: '1.5rem', sm: '2rem' } }}
                    >
                        {reuniao.horariotxt.split("-")[0]}
                    </Typography>
                    <Typography variant="body2" sx={{ fontSize: { xs: '0.8rem', sm: '0.875rem' } }}>
                        {reuniao.horariotxt.split("-")[1]}
                    </Typography>
                </Box>
                <Divider
                    orientation="vertical"
                    flexItem
                    sx={{ display: { xs: 'none', sm: 'block' } }}
                />
                <Divider
                    orientation="horizontal"
                    flexItem
                    sx={{ display: { xs: 'block', sm: 'none' }, width: '100%' }}
                />
                <Box sx={{ flex: 1, width: '100%' }}>
                    <Typography
                        variant="body1"
                        fontWeight={600}
                        sx={{
                            fontSize: { xs: '0.9rem', sm: '1rem' },
                            wordBreak: 'break-word',
                            mb: 0.5
                        }}
                    >
                        {participante}
                    </Typography>
                    <Typography
                        variant="subtitle1"
                        sx={{
                            fontSize: { xs: '0.8rem', sm: '0.875rem' },
                            color: 'text.secondary'
                        }}
                    >
                        {reuniao.mesa.name}
                    </Typography>
                </Box>
            </Box>
        </CardContent>
    </Card>
    )
}
export default function PainelReunioes({ rodada, inscrito }) {

    const [reunioes] = useAllAtiveReunioesByInscricao(rodada, inscrito)
    console.log('reunioes', reunioes)
    console.log('rodada', rodada)
    //intervaloReuniao
    //
    const tempoReuniao = rodada?.tempoReuniao ? parseInt(rodada?.tempoReuniao) : 10; return (
        <Card
            sx={{
                mb: 3,
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <CardContent sx={{ flex: 1, p: { xs: 2, sm: 3 } }}>
                <Typography
                    variant="subtitle1"
                    fontWeight={600}
                    sx={{
                        mb: 2,
                        fontSize: { xs: '1.1rem', sm: '1.25rem' }
                    }}
                >
                    Reuniões
                </Typography>
                {reunioes && reunioes.length > 0 ? (
                    reunioes.map((reuniao) => (
                        <CardReuniaoPainel key={reuniao.uid} tempoReuniao={tempoReuniao} reuniao={reuniao} inscrito={inscrito} />
                    ))) : (
                    <Box sx={{
                        textAlign: 'center',
                        py: { xs: 2, sm: 3 },
                        px: { xs: 1, sm: 2 }
                    }}>
                        <Typography
                            variant="body2"
                            color="textSecondary"
                            sx={{ fontSize: { xs: '0.9rem', sm: '1rem' } }}
                        >
                            Nenhuma reunião agendada.
                        </Typography>
                    </Box>
                )}

            </CardContent>

        </Card>
    )
}
